import { useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import pluralize from "pluralize";
import Swal from "sweetalert2";

import { AppConfirm } from "../../../utils/PopupUtil";
import TenantAPI from "../../api/TenantAPI";
import { handleUpdatedRecords } from "../../../utils/RecordUtils";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";

const useDeleteSubitems = () => {
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const deleteSubitems = async ({
    selectedSubitems,
    fieldSchema,
    parentRecord,
    onSuccess,
  }: {
    selectedSubitems: any;
    fieldSchema: any;
    parentRecord: any;
    onSuccess?: () => void;
  }) => {
    await AppConfirm({
      title: "Delete Subitems",
      text: `Are you sure you want to delete ${
        selectedSubitems?.length
      } ${pluralize(fieldSchema.Name, selectedSubitems.length)}?`,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return TenantAPI.deleteSubitems(
          parentRecord._ModuleAPIName,
          parentRecord.id,
          fieldSchema.APIName,
          selectedSubitems
        )
          .then((data) => {
            const updatedRecord = data.data.data.data;

            handleUpdatedRecords(
              queryClient,
              updatedRecord._ModuleAPIName,
              updatedRecord,
              tenantID ?? ""
            );
            callFunctionIfExists(onSuccess);

            Swal.fire({
              title: "Success",
              text: "Subitems deleted successfully",
              icon: "success",
              confirmButtonColor: "var(--primary)",
            });
          })
          .catch((err) => {
            const message = getErrorMessage(err);

            Swal.fire({
              title: "Error",
              text: message,
              icon: "error",
              confirmButtonColor: "var(--danger)",
            });
          });
      },
    });
  };

  return { deleteSubitems };
};

export default useDeleteSubitems;
